import { ARTICLES_A } from "./articles-a";
import { ARTICLES_B } from "./articles-b";

export const ARTICLES = [...ARTICLES_A, ...ARTICLES_B];

export const CATEGORIES = [
  "Semua",
  "Pinjaman Online",
  "Kartu Kredit",
  "KTA",
  "Edukasi Penyelesaian Utang",
  "Pengelolaan Kewajiban Finansial",
];

export const getArticle = (slug) => ARTICLES.find((a) => a.slug === slug);

export const formatDate = (d) =>
  new Date(d).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });

export const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
